(() => {
  'use strict';
  const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  const url = (path) => `${root.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
  const dateName = 'Order Date';
  const typeName = 'Order Type';
  const timeName = 'Time Window';

  const parseDate = (value) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
  };
  const minDate = () => {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 1);
    return date;
  };
  const dateValue = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  const post = async (path, body) => {
    const response = await fetch(url(path), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    if (response.ok) return response.json();
    let message = 'Unable to update your delivery details. Please try again.';
    try { const error = await response.json(); message = error.description || error.message || message; } catch (_) {}
    throw new Error(message);
  };

  document.addEventListener('DOMContentLoaded', async () => {
    const warning = document.getElementById('bmd-cart-warning');
    const editor = document.getElementById('bmd-cart-editor');
    const checkout = document.getElementById('checkout');
    const dynamicCheckout = document.querySelector('.cart__dynamic-checkout-buttons');
    const date = document.getElementById('cart-date');
    const time = document.getElementById('cart-time');
    const button = document.getElementById('bmd-update-cart');
    const status = document.getElementById('bmd-cart-editor-status');
    const pickup = document.getElementById('cart-pickup');
    const delivery = document.getElementById('cart-delivery');
    if (!warning || !editor || !checkout || !date || !time || !button || !pickup || !delivery) return;

    date.min = dateValue(minDate());
    const setStatus = (message, isError) => {
      if (!status) return;
      status.textContent = message;
      status.classList.toggle('bmd-cart-editor__status--error', Boolean(isError));
    };
    const blockCheckout = () => {
      checkout.disabled = true;
      checkout.setAttribute('aria-disabled', 'true');
      checkout.classList.add('bmd-checkout--blocked');
      if (dynamicCheckout) dynamicCheckout.hidden = true;
    };

    let expiredItems;
    try {
      const cartResponse = await fetch(url('cart.js'), { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      expiredItems = cart.items.filter((item) => {
        const selected = parseDate(item.properties && item.properties[dateName]);
        return selected && selected < minDate();
      });
    } catch (_) { return; }
    if (!expiredItems.length) return;

    const properties = expiredItems[0].properties || {};
    date.value = properties[dateName] || '';
    time.value = properties[timeName] || '';
    (properties[typeName] === 'Pickup' ? pickup : delivery).checked = true;
    warning.hidden = false;
    editor.hidden = false;
    blockCheckout();

    checkout.addEventListener('click', (event) => {
      event.preventDefault();
      editor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      date.focus({ preventScroll: true });
    }, true);

    button.addEventListener('click', async () => {
      const selected = parseDate(date.value);
      if (!selected || selected < minDate()) { setStatus('Please choose tomorrow or a later date.', true); date.focus(); return; }
      if (!time.value) { setStatus('Please select a time window.', true); time.focus(); return; }
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      setStatus('Updating your delivery details…');
      try {
        const orderType = pickup.checked ? pickup.value : delivery.value;
        await post('cart/add.js', { items: expiredItems.map((item) => ({
          id: item.variant_id,
          quantity: item.quantity,
          properties: { ...(item.properties || {}), [typeName]: orderType, [dateName]: date.value, [timeName]: time.value },
          ...(item.selling_plan_allocation ? { selling_plan: item.selling_plan_allocation.selling_plan.id } : {}),
        })) });
        for (const item of expiredItems) await post('cart/change.js', { id: item.key, quantity: 0 });
        window.location.reload();
      } catch (error) {
        setStatus(error.message || 'Unable to update your delivery details. Please try again.', true);
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  });
})();
